// extracted by mini-css-extract-plugin
module.exports = {"navBar":"FooterNavBar_navBar__1pui5","navItem":"FooterNavBar_navItem__23pOb","navLink":"FooterNavBar_navLink__DJpOH"};